export default __webpack_public_path__ + "static/media/Clock.4cdb82e7.svg";